<template>
  <div class="card red all-favorites" style="margin: 2rem;">
    <button type="button" class="back-button" @click="goBack">← Retour</button>
    <div class="form-title">
      <font-awesome-icon class="icon" :icon="['fas', 'heart']" />

      Mes plats préférés
    </div>

    <p v-if="loading" role="status">Chargement de mes plats préférés…</p>
    <p v-else-if="loadError" role="alert">{{ loadError }} <button type="button" class="back-button" @click="load">Réessayer</button></p>
    <p v-else-if="recipes.length === 0">Je retrouve ici les recettes sélectionnées avec un cœur. <router-link to="/recettes/">Découvrir le catalogue des recettes</router-link></p>
    <div style="display: flex;gap: 20px;flex-wrap: wrap;">
      <div v-for="dish of recipes" :key="dish.id" class="favorite-wrap">
        <div class="card liked-dish" :style="{ backgroundImage: 'url(' + mediaSrc(dish.photo) + ')' }" @click="gotoDish(dish)">
          <div class="overlay"><div class="liked-dish-name">{{ dish.name }}</div></div>
        </div>
        <div v-if="selectionMode" class="favorite-select-actions">
          <button v-if="dish.dish_type === 'breakfast'" type="button" @click="addToIdeas(dish, 'breakfast')">Ajouter au petit déjeuner</button>
          <template v-else>
            <button type="button" @click="addToIdeas(dish, 'lunch')">Ajouter au déjeuner</button>
            <button type="button" @click="addToIdeas(dish, 'dinner')">Ajouter au dîner</button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import { api } from "@/api";

export default {
  name: "AllMyLikedDishes",
  data() {
    return {
      recipes: [],
      loading: false,
      loadError: "",
    }
  },
  mounted() {
    this.load();
  },
  computed: {
    selectionMode() { return this.$route.query.selectForIdeas === "1"; },
  },
  methods: {
    goBack() {
      if (this.selectionMode) this.$router.push({ name: "meal-ideas" });
      else this.$router.back();
    },
    addToIdeas(dish, meal) {
      localStorage.setItem("mmm-meal-ideas-favorite", JSON.stringify({ recipe: dish, meal }));
      this.$router.push({ name: "meal-ideas" });
    },
    load() {
      this.loading = true;
      this.loadError = "";
      api.get(`my-liked-recipes/?all=true`)
        .then(response => {
          this.recipes = response.data;
        })
        .catch(() => { this.loadError = "Impossible de charger mes plats préférés."; })
        .finally(() => { this.loading = false; });
    },
    mediaSrc(uri) {
      return `${process.env.VUE_APP_BASE_URL}${uri}`;
    },
    gotoDish(dish) {
      this.$router.push({ name: "dish", params: { id: dish.id } });
    },
  },
};

</script>


<style scoped>
.liked-dish {
  position: relative;
  height: 150px;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
  flex: 0 0 calc((100% - (3 * 20px)) / 4);
}

.liked-dish:hover {
  transform: scale(1.01);
}

.overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.liked-dish:hover .overlay {
  background-color: rgba(255, 255, 255, 0.7);
}

.liked-dish-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 10px;
}

.favorite-wrap { flex: 0 0 calc((100% - (3 * 20px)) / 4); }
.favorite-wrap .liked-dish { width: 100%; flex: none; }
.favorite-select-actions { display: flex; flex-direction: column; gap: 6px; margin-top: 7px; }
.favorite-select-actions button, .back-button { border: 1px solid #77af24; background: #fff; color: #50731d; border-radius: 10px; padding: 8px 10px; cursor: pointer; font-weight: 700; }
.back-button { margin-bottom: 14px; }
@media (max-width: 800px) { .favorite-wrap { flex: 0 0 calc(50% - 10px); } }
</style>
